/**
 * Mensagens com que cada runtime/navegador acusa falha ao baixar um chunk lazy.
 * Depois de um deploy os chunks antigos somem do servidor, e a aba aberta com o
 * bundle anterior falha ao navegar para uma rota ainda não carregada.
 */
const CHUNK_LOAD_ERROR_PATTERNS: readonly RegExp[] = [
  // webpack (JS) e mini-css-extract-plugin (CSS)
  /Loading (CSS )?chunk \S+ failed/i,
  // import() nativo: Chrome / Safari / Firefox
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i
]

export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false

  const { name, message } = error as { name?: unknown; message?: unknown }
  if (name === 'ChunkLoadError') return true

  return (
    typeof message === 'string' &&
    CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(message))
  )
}
